// Step 3: confirm settings + set sync/review policies. Submit triggers the
// parent's create-source action.

import type { ReviewPolicy, SourceType, SyncPolicy } from "./types";

interface Props {
  type: SourceType;
  config: Record<string, unknown>;
  syncPolicy: SyncPolicy;
  reviewPolicy: ReviewPolicy;
  onSyncPolicy(p: SyncPolicy): void;
  onReviewPolicy(p: ReviewPolicy): void;
}

const SYNC_OPTIONS: SyncPolicy[] = ["5m", "1h", "6h", "daily", "manual"];
const REVIEW_OPTIONS: ReviewPolicy[] = [
  "review_required",
  "auto_publish_high_confidence",
  "auto_publish_all",
];

export function ConfirmStep({
  type,
  config,
  syncPolicy,
  reviewPolicy,
  onSyncPolicy,
  onReviewPolicy,
}: Props) {
  return (
    <div className="maisight-sources-form" aria-label="Confirm">
      <dl className="maisight-sources-confirm-list">
        <dt>Type</dt>
        <dd>{type}</dd>
        {Object.entries(config).map(([k, v]) => (
          <Row key={k} k={k} v={v} />
        ))}
      </dl>
      <label className="maisight-sources-field">
        <span>Sync policy</span>
        <select value={syncPolicy} onChange={(e) => onSyncPolicy(e.target.value as SyncPolicy)}>
          {SYNC_OPTIONS.map((p) => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
      </label>
      <label className="maisight-sources-field">
        <span>Review policy</span>
        <select
          value={reviewPolicy}
          onChange={(e) => onReviewPolicy(e.target.value as ReviewPolicy)}
        >
          {REVIEW_OPTIONS.map((p) => (
            <option key={p} value={p}>{p.replaceAll("_", " ")}</option>
          ))}
        </select>
      </label>
    </div>
  );
}

function Row({ k, v }: { k: string; v: unknown }) {
  return (
    <>
      <dt>{k}</dt>
      <dd>{typeof v === "string" ? v : JSON.stringify(v)}</dd>
    </>
  );
}
